/**
 * localStorage: localStorage资源不能滥用，而且要被统一管理
 * 注意：整个项目的localStorage都必须在此模块定义
 *
 * 支持JSON
 */

const localStorage = window.localStorage;

// 白名单：可以使用的cookie名称
const WHITE_LIST = [
  'global_search_history',
  // 列表布局
  'poi_m_web_list_layout',
  // 搜索页用户输入的关键词。为了传递给列表页
  'goods_search_keyword',
  // 取车城市ID（国际租车项目）
  'm_get_city',

  // 白痴统计方案
  'apm_search_type',
  'apm_search_entry',
  'apm_search_source_page',
  'apm_search_source_type',
  'apm_search_hasreported',
  'apm_search_hasreported',
  'm-poi-search',
  // 取车城市ID（国际租车项目）
  'm_get_city',
  // 选择目的地相关
  'm_get_city_poi',
  'm_get_city_name_poi',
  'm_get_city_name_en_poi',
  'm_get_city_state_poi',
  'POI_SELECT_CITY_HISTORY',
  'm_get_destination_poi',
  'HOMEPAGE_PREVIOUS_LOCATION_v1.0',
  'PUNCH_MESSAGE/startCountdown',
  'PUNCH_MESSAGE/updateStatus',
  'HOMEPAGE_PREVIOUS_ZUCHE_LOCATION_v1.0',
  'HOMEPAGE_PREVIOUS_POI_LOCATION_v1.0'
];

function warn(key) {
  if (process.env.NODE_ENV !== 'production') {
    if (WHITE_LIST.indexOf(key) === -1) {
      // eslint-disable-next-line
      console.warn(`警告：白名单没有(${key})`);
    }
  }
}

export const keys = () => {
  return Object.keys(localStorage);
};

// 获取到的value会自动进行JSON.parse操作
export function getItem(key) {
  warn(key);
  let value = localStorage.getItem(key);
  try {
    value = JSON.parse(value);
  } catch (error) {
    // to
  }

  return value;
}

// 保存的value如果是object会自动序列化
export function setItem(key, value) {
  warn(key);
  //
  if (typeof value === 'object') {
    // eslint-disable-next-line
    value = JSON.stringify(value);
  }

  return localStorage.setItem(key, value);
}

export function removeItem(key) {
  return localStorage.removeItem(key);
}

// localStorage 模拟 postMessage
// 不成熟 不要用
const MESSAGE_CHANNEL_KEY = 'TANTU_MESSAGE_CHANNEL_v1.0';

export const postMessage = (target, message) => {
  localStorage.setItem(`${MESSAGE_CHANNEL_KEY}/${target}`, JSON.stringify({
    data: message
  }));
};

export const onMessage = (target, callback, previousTimer) => {
  if (previousTimer) {
    clearTimeout(previousTimer);
    previousTimer = null;
  }
  console.log('waiting message');
  const key = `${MESSAGE_CHANNEL_KEY}/${target}`;
  const message = localStorage.getItem(key);
  if (message) {
    if (callback && callback.call) {
      callback.call(null, JSON.parse(message));
    }
    localStorage.removeItem(key);
    return;
  }

  const timer = setTimeout(() => {
    onMessage(target, callback, timer);
  }, 500);
};

export const getMessage = (target) => {
  const key = `${MESSAGE_CHANNEL_KEY}/${target}`;
  const message = localStorage.getItem(key);
  localStorage.removeItem(key);
  return message ? JSON.parse(message) : null;
};
